window.AG = window.AG || {};
AG.ui = AG.ui || {};

AG.ui.wde = (function () {

    var emailErrors = [];
    var notificationInterval = null;
    var pageTitle = document.title;
    var chatDragInstance = null,
        callbackDragInstance = null;
    var callbackDateString = null,
        callbackDate = null;
    var callbackMsgObserver;


    // Callback function to execute when mutations are observed
    var onCallbackConfirmFail = function (mutationsList, observer) {
        for (var mutation of mutationsList) {
            if (mutation.type === 'attributes') {
                if (mutation.target.innerHTML === 'Select Date &amp; Time') {
                    mutation.target.innerHTML = "Please select a date and time for us to call you.";
                }
            }
        }
    }


    var fixPhoneNumberFormat = function (val) {

        let newVal = val;

        // default to South African phone number if...
        if (val.indexOf("+270") !== -1) {
            newVal = newVal.replace("+270", "+27");
        }
        if (val.substring(0, 2) == "00") {
            newVal = "+27" + newVal.substring(2);
        }
        else if (val.charAt(0) == "0") {
            newVal = "+27" + newVal.substring(1);
        }

        return newVal;

    }

    var isValidEmail = function (val, regex) {

        var valid = true;
        emailErrors = [];

        // validate contains no spaces
        if (val.indexOf(" ") > -1) {
            valid = false;
            emailErrors.push("Email address may not contain spaces");

        } else

            // validate does not end with full stop
            if (val.charAt(val.length - 1) == '.') {
                valid = false;
                emailErrors.push("Email address may not end with a 'full stop'");

            } else

                // validate does not end with an @
                if (val.charAt(val.length - 1) == '@') {
                    valid = false;
                    emailErrors.push("Email address may not end with a '@' character");

                } else

                    // Email Address may not contain @., .@ or ..
                    if (val.indexOf("@.") > -1) {
                        valid = false;
                        emailErrors.push("Email address  may not contain '@.'");

                    } else

                        if (val.indexOf(".@") > -1) {
                            valid = false;
                            emailErrors.push("Email address may not contain '.@'");

                        } else

                            if (val.indexOf("..") > -1) {
                                valid = false;
                                emailErrors.push("Email address may not contain '..'");

                            } else

                                // Email Address must contain exactly one '@' character.
                                if (!(val.indexOf("@") > -1) || (val.indexOf("@@") > -1)) {
                                    valid = false;
                                    emailErrors.push("Email address must contain exactly one '@' character");

                                } else

                                    // Email Address must have at least one full stop.
                                    if (!(val.indexOf(".") > -1)) {
                                        valid = false;
                                        emailErrors.push("Email address must contain at least one 'full stop'");

                                    } else

                                        // // valid does not contain \"~`!#$%^&*()_+={}[]\\\"|'\\:;<>?,/<>\""),
                                        if (val.match(regex) === null) {
                                            valid = false;
                                            emailErrors.push("Please enter a valid email address");

                                        }

        return valid;
    }

    var IsAlphaOrSymbolReg = new RegExp(/^['a-zA-Z\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC\s-]+$/);

    var validateSelect = function (input, form, $) {
        if (input.val()) {
            input.addClass('cx-valid');
            return true;

        } else {
            input.removeClass('cx-valid');
            form.next('.cx-form-error').remove();
            return false;
        }
    }

    var validateName = function (input, form, dragInstance, string, $) {
        if (input.val()) {

            // no numbers only                             
            // var reg = new RegExp(/^([^0-9]*)$/);                           

            if (input.val().match(IsAlphaOrSymbolReg) !== null && input.val().trim() !== '') {
                input.addClass('cx-valid');
                form.next('.cx-form-error').remove();
                dragInstance.updatePanelDimensionsAndConfine();
                return true;
            } else {
                input.removeClass('cx-valid');
                if (!form.next('.cx-form-error').length) form.after("<tr class='cx-form-error'><th>&nbsp;</th><td class='cx-form-error-txt'>Please enter a valid " + string + "</td></tr>");
                dragInstance.updatePanelDimensionsAndConfine();
                return false;
            }

        } else {
            input.removeClass('cx-valid');
            form.next('.cx-form-error').remove();
            dragInstance.updatePanelDimensionsAndConfine();
            return false;
        }
    }

    var validateEmail = function (input, form, dragInstance, $) {
        if (input.val()) {

            // email validation    
            var reg = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g);

            if (isValidEmail(input.val(), reg)) {
                input.addClass('cx-valid');
                form.next('.cx-form-error').remove();
                dragInstance.updatePanelDimensionsAndConfine();
                return true;
            } else {

                input.removeClass('cx-valid');
                form.next('.cx-form-error').remove();
                form.after("<tr class='cx-form-error'><th>&nbsp;</th><td class='cx-form-error-txt'>" + emailErrors + "</td></tr>");

                dragInstance.updatePanelDimensionsAndConfine();
                return false;
            }


        } else {
            input.removeClass('cx-valid');
            form.next('.cx-form-error').remove();
            dragInstance.updatePanelDimensionsAndConfine();
            return false;
        }
    }

    var formOptions = {
        wrapper: "<table></table>",
        inputs: [
            {
                type: "select",
                options: [
                    { text: 'Required', value: "" },
                    { text: 'Mr', value: "Mr" },
                    { text: 'Mrs', value: "Mrs" },
                    { text: 'Miss', value: "Miss" },
                    { text: 'Ms', value: "Ms" },
                    { text: 'Mx', value: "Mx" },
                    { text: 'Prof', value: "Prof" },
                    { text: 'Dr', value: "Dr" },
                    { text: 'Pas', value: "Pas" },
                    { text: 'Rev', value: "Rev" },
                    { text: 'Adv', value: "Adv" },
                    { text: 'Judge', value: "Judge" },
                    { text: 'Capt', value: "Capt" },
                    { text: 'Col', value: "Col" }
                ],
                id: "cx_webchat_form_title",
                name: "title",
                maxlength: "5",
                // placeholder: "@i18n:webchat.ChatFormPlaceholderTitle",
                // label: "@i18n:webchat.ChatFormTitle",
                placeholder: "Required",
                label: "Title",
                wrapper: '<tr><th>{label}</th><td><div class="cx-input-select">{input}<div class="cx-input-select__value">Required</div><div class="cx-input-select__arrow"><span class="cx-input-select__arrow-icon"></span></div></div></td></tr>',
                validateWhileTyping: false,
                validate: function (event, form, input, label, $, CXBus, Common) {

                    if (input) return validateSelect(input, form, $);
                }
            },
            {
                id: "cx_webchat_form_firstname",
                name: "firstname",
                maxlength: "100",
                placeholder: "@i18n:webchat.ChatFormPlaceholderFirstName",
                label: "@i18n:webchat.ChatFormFirstName",
                validateWhileTyping: false,
                validate: function (event, form, input, label, $, CXBus, Common) {

                    if (input) return validateName(input, form, chatDragInstance, 'name', $);
                }
            },
            {
                id: "cx_webchat_form_lastname",
                name: "lastname",
                maxlength: "100",
                placeholder: "@i18n:webchat.ChatFormPlaceholderLastName",
                label: "@i18n:webchat.ChatFormLastName",
                validateWhileTyping: false,
                validate: function (event, form, input, label, $, CXBus, Common) {

                    if (input) return validateName(input, form, chatDragInstance, 'surname', $);
                }
            },
            {
                type: "email",
                id: "cx_webchat_form_email",
                name: "email",
                maxlength: "100",
                placeholder: "@i18n:webchat.ChatFormPlaceholderEmail",
                label: "@i18n:webchat.ChatFormEmail",
                //wrapper:"<tr><th>{label}</th><td>{input}</td></tr><tr class='cx-form-helper'><th>&nbsp;</th><td class='cx-form-helper-txt'>You have the option of receiving an email transcript of your chat.</td></tr>",
                validateWhileTyping: false,
                validate: function (event, form, input, label, $, CXBus, Common) {

                    if (input) return validateEmail(input, form, chatDragInstance, $);
                }
            },
            {
                type: "checkbox",
                id: "cx_webchat_form_transcript",
                name: "transcript",
                // placeholder: "@i18n:webchat.ChatFormPlaceholderTranscript",
                // label: "@i18n:webchat.ChatFormTranscript",               
                label: "Receive an email copy of your chat?",
                wrapper: '<tr><th colspan="2"><div class="cx-input-checkbox">{input}{label}</div></th></tr>',
                validateWhileTyping: true,
                validate: function (event, form, input, label, $, CXBus, Common) {
                    if (input) {
                        if (input.is(':checked')) {
                            form.next('.cx-form-helper').remove();
                            form.after("<tr class='cx-form-helper'><td colspan='2' class='cx-form-helper-txt'>Your chat conversation will be emailed to the address provided above.</td></tr>");
                        } else {
                            form.next('.cx-form-helper').remove();
                        }
                        chatDragInstance.updatePanelDimensionsAndConfine();
                        return true;
                    }
                }
            }
        ]
    };

    var callbackFormOptions = {
        wrapper: "<table></table>",
        inputs: [
            {
                type: "select",
                options: [
                    { text: 'Required', value: "" },
                    { text: 'Mr', value: "Mr" },
                    { text: 'Mrs', value: "Mrs" },
                    { text: 'Miss', value: "Miss" },
                    { text: 'Ms', value: "Ms" },
                    { text: 'Mx', value: "Mx" },
                    { text: 'Prof', value: "Prof" },
                    { text: 'Dr', value: "Dr" },
                    { text: 'Pas', value: "Pas" },
                    { text: 'Rev', value: "Rev" },
                    { text: 'Adv', value: "Adv" },
                    { text: 'Judge', value: "Judge" },
                    { text: 'Capt', value: "Capt" },
                    { text: 'Col', value: "Col" }
                ],
                id: "cx_callback_form_title",
                name: "title",
                maxlength: "5",
                // placeholder: "@i18n:webchat.CallbackPlaceholderTitle",
                // label: "@i18n:callback.ChatFormTitle",
                placeholder: "Required",
                label: "Title",
                wrapper: '<tr><th>{label}</th><td><div class="cx-input-select">{input}<div class="cx-input-select__value">Required</div><div class="cx-input-select__arrow"><span class="cx-input-select__arrow-icon"></span></div></div></td></tr>',
                validateWhileTyping: false,
                validate: function (event, form, input, label, $, CXBus, Common) {

                    if (input) return validateSelect(input, form, $);

                }
            },

            {
                id: "cx_form_callback_firstname",
                name: "firstname",
                maxlength: "100",
                placeholder: "@i18n:callback.CallbackPlaceholderRequired",
                label: "@i18n:callback.CallbackFirstName",
                validateWhileTyping: false,
                validate: function (event, form, input, label, $, CXBus, Common) {

                    if (input) return validateName(input, form, callbackDragInstance, 'name', $);

                }
            },

            {
                id: "cx_form_callback_lastname",
                name: "lastname",
                maxlength: "100",
                placeholder: "@i18n:callback.CallbackPlaceholderRequired",
                label: "@i18n:callback.CallbackLastName",
                validateWhileTyping: false,
                validate: function (event, form, input, label, $, CXBus, Common) {

                    if (input) return validateName(input, form, callbackDragInstance, 'surname', $);

                }
            },

            {
                id: "cx_form_callback_phone_number",
                name: "phonenumber",
                maxlength: "14",
                placeholder: "@i18n:callback.CallbackPlaceholderRequired",
                label: "@i18n:callback.CallbackPhoneNumber",
                onkeypress: function (e) {
                    return (e.charCode >= 48 && e.charCode <= 57) || (e.charCode == 43)
                },
                validateWhileTyping: false,
                validate: function (event, form, input, label, $, CXBus, Common) {
                    if (input) {
                        if (input.val()) {

                            input.val(fixPhoneNumberFormat(input.val()));

                            if (input.val().length > 10 && input.val().trim() !== '') {
                                input.addClass('cx-valid');
                                form.next('.cx-form-error').remove();
                                callbackDragInstance.updatePanelDimensionsAndConfine();
                                return true;
                            } else {
                                input.removeClass('cx-valid');
                                if (!form.next('.cx-form-error').length) form.after("<tr class='cx-form-error'><th>&nbsp;</th><td class='cx-form-error-txt'>Please enter a valid phone number</td></tr>");
                                callbackDragInstance.updatePanelDimensionsAndConfine();
                                return false;
                            }

                        } else {
                            input.removeClass('cx-valid');
                            form.next('.cx-form-error').remove();
                            callbackDragInstance.updatePanelDimensionsAndConfine();
                            return false;
                        }

                    }
                }
            },

            {
                id: "cx_form_callback_email",
                name: "email",
                maxlength: "100",
                placeholder: "@i18n:callback.CallbackPlaceholderRequired",
                label: "Email",
                validateWhileTyping: false,
                validate: function (event, form, input, label, $, CXBus, Common) {

                    if (input) return validateEmail(input, form, callbackDragInstance, $);

                }
            },

            {
                type: "select",
                options: [
                    { text: 'Required', value: "" },
                    { text: 'Learn more about Allan Gray', value: "Learn more about Allan Gray" },
                    { text: 'Access investments online', value: "Access investments online" },
                    { text: 'How to transact', value: "How to transact" },
                    { text: 'Follow up on a transaction', value: "Follow up on a transaction" },
                    { text: 'Request investment statements', value: "Request investment statements" },
                    { text: 'Other', value: "Other" }
                ],
                id: "cx_callback_form_request",
                name: "requestType",
                maxlength: "5",
                // placeholder: "@i18n:webchat.CallbackPlaceholderTitle",
                // label: "@i18n:callback.ChatFormTitle",
                placeholder: "Required",
                label: "Request type",
                wrapper: '<tr><th>{label}</th><td><div class="cx-input-select">{input}<div class="cx-input-select__value">Required</div><div class="cx-input-select__arrow"><span class="cx-input-select__arrow-icon"></span></div></div></td></tr>',
                validateWhileTyping: false,
                validate: function (event, form, input, label, $, CXBus, Common) {

                    if (input) return validateSelect(input, form, $);

                }
            },

            {
                id: "cx_form_callback_subject",
                name: "subject",
                type: "textarea",
                maxlength: "100",
                placeholder: "@i18n:callback.CallbackPlaceholderOptional",
                label: "@i18n:callback.CallbackNotes"
            },
            {
                id: "cx_form_callback_alerttype",
                name: "AlertType",
                type: "hidden",
                value: "Web-callback"
            },
            {
                id: "cx_form_callback_referURL",
                name: "referURL",
                type: "hidden",
                value: window.location.pathname
            }
        ]
    }

    var registerExtensions = function (params) {
        window._genesys.widgets.extensions = window._genesys.widgets.extensions || {};

        // webchat extensions    
        window._genesys.widgets.extensions["WebChatActions"] = function ($, CXBus, Common) {
            var oWebChatActions = CXBus.registerPlugin("WebChatActions");

            oWebChatActions.subscribe("WebChat.opened", function (e) {

                // hide sidebar
                $('.cx-widget.cx-sidebar').hide();

                // hide contact us launcher
                // $('#wde-assistance-section, #wde-contact-heading').hide();

                // draggable chat
                chatDragInstance = new AG.ui.wdeMoveableChat();
                chatDragInstance.initDraggable(".cx-desktop .cx-widget.cx-webchat");

                AG.ui.wdeResizeableChat.initResizeable(".cx-desktop .cx-widget.cx-webchat.cx-transcript-view");

                // focus title field & remove invalid styling from Name field after blur                
                $('#cx_webchat_form_title').focus();
                setTimeout(function () {
                    $('#cx_webchat_form_firstname').removeClass('cx-error');
                }, 10);

                // init dropdown select customization
                initCustomSelect($);


                // if scrolled within widget area              
                $('body').on("mousewheel.webchatscroll wheel.webchatscroll DOMMouseScroll.webchatscroll MozMousePixelScroll.webchatscroll touchmove.webchatscroll", '.cx-widget.cx-common-container', function (e) {

                    // if transcript area is not overflown, disable page scroll
                    // var transcriptElm = document.querySelector('.cx-transcript');
                    // if( !(transcriptElm.scrollHeight>transcriptElm.clientHeight||transcriptElm.scrollWidth>transcriptElm.clientWidth) ){                                   
                    //     e.stopPropagation();
                    //     e.preventDefault();
                    //     console.log('but why')
                    // }

                    if (params.onWebchatScroll) params.onWebchatScroll();

                });

                $('body').addClass('wde-open');

                if (params.afterWebchatOpened) params.afterWebchatOpened();

            });

            oWebChatActions.subscribe("WebChat.started", function (e) {
                chatDragInstance.updatePanelDimensionsAndConfine();

                AG.ui.wdeResizeableChat.initResizeable(".cx-desktop .cx-widget.cx-webchat.cx-transcript-view");
            });

            oWebChatActions.subscribe("WebChat.unminimized", function (e) {
                $('body').addClass('wde-open');
                chatDragInstance.updatePanelDimensionsAndConfine();
            });

            oWebChatActions.subscribe("WebChat.minimized", function (e) {

                $('body').removeClass('wde-open');

                // maximize chat by clicking anywhere on webchat titlebar (mobile only)
                var trigger = document.querySelector(".cx-mobile .cx-widget.cx-webchat.cx-minimize .cx-titlebar");
                if (trigger) {
                    trigger.onclick = function () {
                        oWebChatActions.command('WebChat.minimize').done(function (e) {
                            // chat maximized. unset listener                          
                            trigger.onclick = null;
                        }).fail(function (e) {
                            // toggle chat failed
                            console.log('failed to maximize');
                        });
                    };
                }
            });


            function clearMsgNotification() {
                clearInterval(notificationInterval);
                document.title = pageTitle;
            }

            oWebChatActions.subscribe("WebChatService.messageReceived", function (e) {

                // flashing page title new message notify
                var messageFromType = e.data.messages[0].from.type;
                var messageType = e.data.messages[0].type;

                if (messageFromType === 'Agent' && messageType === 'Message') {

                    clearMsgNotification();
                    pageTitle = document.title;

                    var newMessageTitle = 'New message received!';
                    var notifySpeed = 1000;
                    var notifyToggle = false;
                    //var notifyItt = 0;
                    //var notifyCount = 20;


                    document.title = newMessageTitle;
                    notificationInterval = setInterval(function () {
                        // notifyItt++;
                        // if(notifyItt < notifyCount){

                        notifyToggle ? document.title = newMessageTitle : document.title = pageTitle;
                        notifyToggle = !notifyToggle;

                        // } else {                        
                        //     clearMsgNotification();
                        // }
                    }, notifySpeed);

                }


            });

            oWebChatActions.subscribe("WebChatService.ended", function (e) {

                // if chat session ended, clear the flashing page title
                clearMsgNotification();

            });

            oWebChatActions.subscribe("WebChatService.clientTypingStarted", function (e) {

                // if client started typing, let's clear the flashing page title
                clearMsgNotification();

            });

            oWebChatActions.subscribe("WebChat.closed", function (e) {

                // show sidebar
                $('.cx-widget.cx-sidebar').show();

                // unbind scroll listeners         
                $('body').off("mousewheel.webchatscroll wheel.webchatscroll DOMMouseScroll.webchatscroll MozMousePixelScroll.webchatscroll touchmove.webchatscroll", '.cx-widget.cx-common-container');

                // clear the flashing page title
                clearMsgNotification();

                $('body').removeClass('wde-open');

                if (params.afterWebchatClosed) params.afterWebchatClosed();

            });


        },

            // callback extensions    
            window._genesys.widgets.extensions["CallbackActions"] = function ($, CXBus, Common) {

                var oCallbackActions = CXBus.registerPlugin("CallbackActions");

                // disable fullpage scrolling when callback widget open
                oCallbackActions.subscribe("Callback.opened", function (e) {

                    // hide sidebar
                    $('.cx-widget.cx-sidebar').hide();

                    // draggable chat
                    callbackDragInstance = new AG.ui.wdeMoveableChat();
                    callbackDragInstance.initDraggable(".cx-desktop .cx-widget.cx-callback");

                    // focus title field & remove invalid styling from Name field after blur                
                    $('#cx_callback_form_title').focus();
                    setTimeout(function () {
                        $('#cx_callback_form_firstname').removeClass('cx-error');
                    }, 10);

                    // change phone field to type tel
                    $('#cx_form_callback_phone_number').attr('type', 'tel');

                    // init dropdown select customization
                    initCustomSelect($);

                    // hacky way to update callback confirm error message
                    // var failMsgNode = document.querySelector('.cx-callback .cx-dialog.cx-error-container p.cx-fail-message');
                    // callbackMsgObserver = new MutationObserver(onCallbackConfirmFail);
                    // callbackMsgObserver.observe(failMsgNode, { attributes: true });

                    $('body').addClass('wde-open');

                    if (params.afterCallbackOpened) params.afterCallbackOpened();
                });

                oCallbackActions.subscribe("Callback.unminimized", function (e) {
                    $('body').addClass('wde-open');
                });

                oCallbackActions.subscribe("Callback.minimized", function (e) {
                    $('body').removeClass('wde-open');
                });

                oCallbackActions.subscribe("Callback.closed", function (e) {

                    // show sidebar
                    $('.cx-widget.cx-sidebar').show();

                    // if(callbackMsgObserver) callbackMsgObserver.disconnect();

                    $('body').removeClass('wde-open');

                    if (params.afterCallbackClosed) params.afterCallbackClosed();
                });


                oCallbackActions.subscribe("Callback.submitted", function (e) {
                    callbackDate = e.data.form._desired_time;
                });

                oCallbackActions.subscribe("Callback.completed", function (e) {

                    var $confirmationWrapper = $('.cx-confirmation-wrapper');
                    $confirmationWrapper.append('<div class="confirm-info"></div>');


                    // add number (formatted with spaces if local)             
                    if (e.data.form._customer_number !== '') {

                        // hide default phone number insertion
                        $('#cx-callback-result-desc, #cx-callback-result-number').hide();

                        var phoneNumber = e.data.form._customer_number;
                        if (phoneNumber.substring(0, 3) === '+27') {
                            phoneNumber = [phoneNumber.slice(0, -7), " ", phoneNumber.slice(-7, -4), " ", phoneNumber.slice(-4)].join('');
                        }
                        $confirmationWrapper.find('.confirm-info').append('<div class="confirm-info__phone">We will call you at the number provided: <strong>' + phoneNumber + '</strong></div>');
                    }

                    // add date string from saved date string
                    if (callbackDateString != null) {
                        $confirmationWrapper.find('.confirm-info').append('<div class="confirm-info__date">Date and time: <time datetime="' + callbackDate + '"><strong>' + callbackDateString + '</strong></time></div>');

                        // ADD TO CAL LINKS
                        var callbackCalTitle = 'Allan Gray callback';
                        var callbackCalDescription = '';
                        var callbackCalSubject = '';
                        if (e.data.form.requestType !== '') callbackCalDescription = 'Request type: ' + e.data.form.requestType;
                        if (e.data.form.subject !== '') callbackCalSubject = 'Comments: ' + e.data.form.subject;

                        // calculate end date
                        var callbackDuration = parseInt(window._genesys.widgets.calendar.calendarHours.interval);
                        var callbackDateObj = new Date(callbackDate);
                        var callbackDateObjEnd = new Date(callbackDateObj.getTime() + callbackDuration * 60000);
                        var callbackDateEnd = callbackDateObjEnd.toISOString();

                        // format for google cal
                        var googleCalStart = callbackDate.replace(/[:\-.]/g, '');
                        var googleCalEnd = callbackDateEnd.replace(/[:\-.]/g, '');

                        // format for outlook 
                        // bit of a hack, but subtract users timezone offset, convert to 'ISO format without the Z'd
                        var outlookCalStartObj = new Date(callbackDateObj.getTime() - (callbackDateObj.getTimezoneOffset() * 60000));
                        var outlookCalStartZ = outlookCalStartObj.toISOString();
                        var outlookCalStart = outlookCalStartZ.substring(0, outlookCalStartZ.length - 1);

                        var outlookCalEndObj = new Date(callbackDateObjEnd.getTime() - (callbackDateObjEnd.getTimezoneOffset() * 60000));
                        var outlookCalEndZ = outlookCalEndObj.toISOString();
                        var outlookCalEnd = outlookCalEndZ.substring(0, outlookCalEndZ.length - 1);


                        // build 'add to calendar' string
                        var addToCalStr =
                            `
                        <div class="confirm-info__cal">
                            Add to 
                            
                            <a href="https://calendar.google.com/calendar/render?action=TEMPLATE&dates=${encodeURIComponent(googleCalStart)}%2F${encodeURIComponent(googleCalEnd)}&details=${encodeURIComponent(callbackCalDescription)}%0A${encodeURIComponent(callbackCalSubject)}&location=${encodeURIComponent(phoneNumber)}&text=${encodeURIComponent(callbackCalTitle)}" target="_blank">Google</a> |

                            <a href="https://outlook.live.com/calendar/0/deeplink/compose?body=${encodeURIComponent(callbackCalDescription)}&enddt=${encodeURIComponent(outlookCalEnd)}&location=${encodeURIComponent(phoneNumber)}&path=%2Fcalendar%2Faction%2Fcompose&rru=addevent&startdt=${encodeURIComponent(outlookCalStart)}&subject=${encodeURIComponent(callbackCalTitle)}" target="_blank">Outlook</a> |

                            <a href="https://outlook.office.com/calendar/0/deeplink/compose?body=${encodeURIComponent(callbackCalDescription)}&enddt=${encodeURIComponent(callbackDateEnd)}&location=${encodeURIComponent(phoneNumber)}&path=%2Fcalendar%2Faction%2Fcompose&rru=addevent&startdt=${encodeURIComponent(callbackDate)}&subject=${encodeURIComponent(callbackCalTitle)}" target="_blank">Office 365</a>

                            calendar
                        </div>
                    `;

                        $confirmationWrapper.find('.confirm-info').append(addToCalStr);

                        // ADD TO CAL LINKS
                    }


                    // add request type if exist            
                    if (e.data.form.requestType !== '') $confirmationWrapper.find('.confirm-info').append('<div class="confirm-info__request">Request type: <strong>' + e.data.form.requestType + '</strong></div>');

                    // add comments if exist
                    if (e.data.form.subject !== '') $confirmationWrapper.find('.confirm-info').append('<div class="confirm-info__comments">Comments: <strong>' + e.data.form.subject + '</strong></div>');

                    if (params.afterCallbackComplete) params.afterCallbackComplete();
                });


            },

            // calendar extensions    
            window._genesys.widgets.extensions["CalendarActions"] = function ($, CXBus, Common) {
                var oCalendarActions = CXBus.registerPlugin("CalendarActions");

                oCalendarActions.subscribe("Calendar.selectedDateTime", function (e) {

                    callbackDateString = e.data.dayString + ' - ';
                    callbackDateString += e.data.dateString + ' - ';
                    callbackDateString += e.data.timeString;

                });

            },

            // channel selector extension 
            window._genesys.widgets.extensions["ChannelSelectorActions"] = function ($, CXBus, Common) {
                var oChannelSelectorActions = CXBus.registerPlugin("ChannelSelectorActions");

                oChannelSelectorActions.subscribe("ChannelSelector.opened", function (e) {
                    // modify hardcoded 'Web Chat' text
                    $('#cx-Channel01-name').text('Live chat');
                });
            }

    }

    var initCustomSelect = function ($) {

        // custom select control logic
        $('.cx-input-select').each(function () {
            var $this = $(this);
            var $select = $this.find('select');
            var $val = $this.find('.cx-input-select__value');
            $val.text($select.find(':selected').text());
            $select.val() !== '' ? $val.removeClass('is-placeholder') : $val.addClass('is-placeholder');

            $select.on('change', function () {
                $val.text($select.find(':selected').text());
                $select.val() !== '' ? $val.removeClass('is-placeholder') : $val.addClass('is-placeholder');
            });
        });
    }


    var onConfigLoaded = function (pluginsPath) {
        CXBus.configure({ debug: false, pluginsPath: pluginsPath + 'plugins/' });
        CXBus.loadPlugin('widgets-core');
    }


    /**
     * @param {Object} params The parameters described below
     * showSidebar: boolean (default: false)
     * pluginsPath: string (default: '/static/genesys/')
     * widgetServiceBaseUrl: string (default: 'https://www.allangray.co.za')
     * 
     * Callbacks:
     * beforeWebServiceLoad
     * afterWebServiceLoad: agentsAvailable (boolean)
     * afterWebchatOpened
     * onWebchatScroll
     * afterWebchatClosed
     * afterCallbackOpened
     * afterCallbackClosed
     */
    function initWDE(params) {

        window._genesys = window._genesys || {};

        // set defaults 
        params.showSidebar = typeof params.showSidebar !== 'undefined' ? params.showSidebar : false;
        params.widgetServiceBaseUrl = typeof params.widgetServiceBaseUrl !== 'undefined' ? params.widgetServiceBaseUrl : 'https://www.allangray.co.za';
        params.pluginsPath = typeof params.pluginsPath !== 'undefined' ? params.pluginsPath : '/static/genesys/';


        if (params.beforeWebServiceLoad) params.beforeWebServiceLoad();

        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
            if (xhr.status === 200) {

                window._genesys.widgets = JSON.parse(xhr.responseText);

                // show/hide sidebar logic
                if (params.showSidebar) {
                    // console.log('show sidebar');

                    //
                    // HAS CALLBACK PARAMS
                    //
                    if (window._genesys.widgets.callback != null) {

                        // if mobile, disable default sidebar and inject own version
                        if (window.matchMedia("(max-width:767px)").matches) {
                            window._genesys.widgets.sidebar.showOnStartup = false;

                            // else show channel selector button
                            document.body.insertAdjacentHTML('beforeend', '<div class="wde-mobile-button" title="Get in touch" onclick="_genesys.widgets.bus.command(\'ChannelSelector.open\');"><div class="wde-icon"></div><div class="wde-name">Get in touch</div></div>');


                        } else {
                            window._genesys.widgets.sidebar.showOnStartup = true;
                        }

                        //
                        // NO CALLBACK PARAMS (WEBCHAT ONLY)
                        //
                    } else {

                        // only show widget if agents available and within operating hours
                        if (window._genesys.widgets.webchat.agentsAvailable) {

                            if (window.matchMedia("(max-width:767px)").matches) {
                                window._genesys.widgets.sidebar.showOnStartup = false;

                                document.body.insertAdjacentHTML('beforeend', '<div class="wde-mobile-button" title="Live Chat" onclick="_genesys.widgets.bus.command(\'WebChat.open\');"><div class="wde-icon"></div><div class="wde-name">Live Chat</div></div>');

                            } else {
                                window._genesys.widgets.sidebar.showOnStartup = true;
                            }

                        } else {
                            window._genesys.widgets.sidebar.showOnStartup = false;
                        }

                    }


                } else {
                    // console.log('hide sidebar');
                    window._genesys.widgets.sidebar.showOnStartup = false;
                }

                // afterWebServiceLoad callback
                if (params.afterWebServiceLoad) {
                    params.afterWebServiceLoad(
                        {
                            "webchatAvailable": window._genesys.widgets.webchat && window._genesys.widgets.webchat.agentsAvailable,
                            "callbackAvailable": window._genesys.widgets.callback && window._genesys.widgets.callback.scheduledCallback
                        }
                    );
                }




                // 3. customise webchat registration form
                if (window._genesys.widgets.webchat != null) window._genesys.widgets.webchat.form = formOptions;

                // 3. customise callback registration form
                if (window._genesys.widgets.callback != null) window._genesys.widgets.callback.form = callbackFormOptions;



                // 4. extensions
                registerExtensions(params);

                // 5. inject custom webchat css
                var l = document.createElement('link');
                l.setAttribute('href', params.pluginsPath + 'genesys_widgets_custom.css');
                l.setAttribute('rel', "stylesheet");
                l.setAttribute('type', "text/css");
                l.setAttribute('id', "genesys_widgets_custom");
                document.body.appendChild(l);


                var s = document.createElement('script');
                s.setAttribute('src', params.pluginsPath + 'cxbus.min.js');
                s.setAttribute('onload', "javascript:AG.ui.wde.onConfigLoaded('" + params.pluginsPath + "');");
                document.body.appendChild(s);

            }
            else {
                console.error(xhr.statusText);
            }
        };
        xhr.onerror = function () {
            console.error("Network Error");
        };
        var data = {
            url: window.location.href
        };

        xhr.open('GET', params.widgetServiceBaseUrl + '/servicing/widgets/main/configuration?data=' + encodeURIComponent(JSON.stringify(data)), true);
        //console.log(params.widgetServiceBaseUrl + '/servicing/widgets/main/configuration?data=' + encodeURIComponent(JSON.stringify(data)));

        xhr.send();
    }

    return {
        initWDE: initWDE,
        onConfigLoaded: onConfigLoaded
    };

}());